import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import useOnEnterPress from '../../../hooks/EnterPress';
import CommentInput from '../../Inputs/CommentInput/CommentInput';
import Tag from '../../../ui_components/Tag/Tag';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import Alert from '../../../ui_components/Alert/Alert';
import AlertType from '../../../ui_components/Alert/AlertType';
import Link from '../../../ui_components/Link/Link';
import TextInput from '../../../ui_components/TextInput/TextInput';
import TextInputType from '../../../ui_components/TextInput/TextInputType';
import CollectDamagedArticleStockButtonProperties from './CollectDamagedArticleStockButtonProperties';
import CollectDamagedArticleStockStore from './CollectDamagedArticleStockButtonStore';
import {useStyles} from './CollectDamagedArticleStockButton.style';

const CollectDamagedArticleStockButton: React.FC<CollectDamagedArticleStockButtonProperties> = ({
                                                                                  entityId,
                                                                                  articleId,
                                                                                  damagedAmount,
                                                                                  disabled = false,
                                                                                  className = '',
                                                                                  onClick = () => {
                                                                                  },
                                                                                  onSave = () => {
                                                                                  },
                                                                              }) => {
    const classes = useStyles();

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const store = new CollectDamagedArticleStockStore(commonContext, entityId, articleId, damagedAmount);

    const text = 'Recoger todos los artículos dañados';

    const handleOnclick = async () => {
        store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.closeModal();
        onSave();
    }

    const onAmountChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        store.amount = +event.target.value;
    }

    const onCommentChange = (comment: string) => store.comment = comment;

    const onCollectSave = async () => {
        const saved = await store.save();
        if (saved) {
            store.closeModal();
            onSave();
        }
    }
    useOnEnterPress(onCollectSave, [store]);

    return <Observer>
        {() => (
            <>
                <Modal fullScreen={false} loading={store.loading} title={text} onClose={onCloseModal} open={store.isModalOpen}>
                    <div className={classes.modal_container}>
                        <div className={classes.hint}>
                            <Tag startIcon={GppMaybeIcon} text={'La cantidad recogida se descuenta del inventario dañado. Por defecto se recoge todo, pero puede ajustar la cantidad para una recogida parcial.'}/>
                        </div>
                        <div className={classes.amount_row}>
                            <TextInput
                                type={TextInputType.NUMBER}
                                value={store.amount || ''}
                                onChange={onAmountChange}
                                label={'Cantidad recogida'}
                                fullWidth
                            />
                            <Link className={classes.collect_all_link} text={'Seleccionar todo'} onClick={() => store.collectAll()}/>
                        </div>
                        <CommentInput
                            lines={3}
                            onChange={onCommentChange}
                            fullWidth
                            value={store.comment}
                            className={classes.input}
                        />
                        {store.success && (
                            <Alert
                                className={classes.alert}
                                text={'Estoque actualizado con éxito'}
                                type={AlertType.SUCCESS}
                            />
                        )}
                        <div className={classes.btn_container}>
                            <Button
                                disabled={!store.enableButton}
                                loading={store.loading} className={classes.save_btn} onClick={onCollectSave}
                                type={ButtonType.SECONDARY}
                                text={i18n.translate("SAVE")}/>
                        </div>
                    </div>
                </Modal>
                <Link className={className} text={text} onClick={handleOnclick} disabled={disabled}/>
            </>
        )}
    </Observer>
}

export default CollectDamagedArticleStockButton;
